import {Component, Inject, PLATFORM_ID} from '@angular/core';
import {HelperService} from './shared/services/helper.service';
import {ApiServices} from './shared/services/api.service';
import {DataService} from './shared/services/data.service';
import {Subscription} from 'rxjs';
import {isPlatformBrowser} from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import {MetaService} from './shared/services/meta.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'dealer-tunerstop';
  hideShowFooterSubscription: Subscription;
  hideHeaderFooter = false;
  metaTags:any;

  constructor(
    private helperService: HelperService,
    private apiService: ApiServices,
    private dataService: DataService,
    private meta: Meta,
    private metaService: MetaService,
    @Inject(PLATFORM_ID) private platformID: any,
    ) {
    if (isPlatformBrowser(this.platformID)) {
      const sessionId = localStorage.getItem('session_id');
      if (!sessionId) {
        this.helperService.generateSessionId();
      }
      this.getMyCart();
      this.hideShowFooterSubscription = this.dataService.hideHeaderFooter.asObservable().subscribe(
        visibility => this.hideHeaderFooter = visibility
      );
    }
    this.metaTags = meta;
    // this.meta.updateTag({ name: 'google-site-verification', content: 'flDOrjGuYWjQDx-C4zTnAfGybKHZgv-c1vzFEuJjly4'});

    this.metaService.updateCanonicalURL();
  }

  getMyCart(): void {
    const access_token = localStorage.getItem('ts_vendor_access_token');

    if(access_token) {
      this.apiService.getCart().subscribe(response => {
        if (response.status) {
          this.dataService.setCartData(response);
        }
      });
    }
  }
  

}
